angular.module('unica_event_tag.event_tag_controllers')

.controller('EventTagListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm,
	EventTagListService, EventTagDeleteService
) {

	$scope.eventTagList = [];

	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.loadEventTagLists = function()
	{
		$scope.showLoader();

		EventTagListService
			.list( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.eventTagList = $scope.eventTagList.concat( data );
				}
			});
	};

	$scope.loadEventTagLists();

	$scope.deleteEventTag = function(eventTagId)
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare questo tag?',
			text: 'Confermi la cancellazione del tag?'
		}).then(function() {

			$scope.showLoader();

			EventTagDeleteService
				.delete( eventTagId )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						angular.forEach($scope.eventTagList, function(eventTag, key) {
							if ( eventTag.id === eventTagId ) {
								$scope.eventTagList.splice(key, 1);
							}
						});

						$scope.showSuccessMsg('Tag eliminato con successo!', '');
					}
				});

		}, function() {
			// Cancel
		});
	};

});